import { z } from 'zod';
import { CrmDealStage, CrmInboundChannel } from './crm';

export const CrmPartyUnifiedDealDto = z.object({
  id: z.uuid(),
  sourceKey: z.string().min(1).max(200),
  title: z.string().min(1).max(200),
  stage: CrmDealStage,
  contactUserId: z.uuid(),
  inboundChannel: CrmInboundChannel,
  contactLabel: z.string().min(1).max(120),
});
export type CrmPartyUnifiedDealDto = z.infer<typeof CrmPartyUnifiedDealDto>;

export const CrmPartyUnifiedPanelDto = z.object({
  partyId: z.uuid(),
  identityCount: z.number().int().positive(),
  userIds: z.array(z.uuid()),
  manyChatContactIds: z.array(z.uuid()),
  manualLeadIds: z.array(z.uuid()),
  deals: z.array(CrmPartyUnifiedDealDto),
});
export type CrmPartyUnifiedPanelDto = z.infer<typeof CrmPartyUnifiedPanelDto>;
